import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { withRouter } from 'react-router';
import localize from '../hoc/localize';
import { compose } from 'redux';

class NotFound extends React.Component {

    handleGoToPrevious = (e) => {
        this.props.history.goBack();
    }
    handleGoToLogin = () => {
        this.props.history.push("/");
    }
    render() {
        //!DBTRANS! @m0229@ That means page not found. !DEVNOTE! Error cause
        //!DBTRANS! @m0230@ Go back to the previous page. !DEVNOTE! Button label
        //!DBTRANS! @m0231@ ... or ... !DEVNOTE! Button label
        //!DBTRANS! @m0232@ Go back to the login page. !DEVNOTE! Button label

        return (
            <div className="not-found">
                <div className="header">
                    <img src={require('../img/super-cloud.png')} alt="Super SOM" />
                    <h2>404</h2>
                </div>

                <p>{this.props.returnLocalizedString("m0229")}</p>

                <div><Button onClick={this.handleGoToPrevious}>{this.props.returnLocalizedString("m0230")}</Button></div>

                <p>{this.props.returnLocalizedString("m0231")}</p>

                <div><Button onClick={this.handleGoToLogin}>{this.props.returnLocalizedString("m0232")}</Button></div>
            </div>
        );
    }
}
export default compose(localize, withRouter)(NotFound);



// WEBPACK FOOTER //
// ./src/containers/NotFound.js